import { render, staticRenderFns } from "./SocialAdDemographicsChart.vue?vue&type=template&id=5e8d21b0&scoped=true&"
import script from "./SocialAdDemographicsChart.vue?vue&type=script&lang=ts&"
export * from "./SocialAdDemographicsChart.vue?vue&type=script&lang=ts&"
import style0 from "./SocialAdDemographicsChart.vue?vue&type=style&index=0&id=5e8d21b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d21b0",
  null
  
)

export default component.exports